import { requestData } from "./utils";

export default class OTTModule {
  getOTTList(query, link: string = "/query/ott") {
    return requestData("GET", link, query);
  }
  getOTTProviders() {
    return requestData("GET", `/query/ott/providers`);
  }
  add(app) {
    return requestData("POST", `/ott`, {
      ...app,
    });
  }
  update(app, account_id) {
    return requestData("PUT", `/ott/${account_id}`, {
      ...app,
    });
  }
  activate(account_id) {
    return requestData("POST", `/ott/activate/${account_id}`);
  }
  suspend(account_id, reason) {
    return requestData("POST", `/ott/suspend/${account_id}`, { reason });
  }
  unsuspend(account_id) {
    return requestData("POST", `/ott/unsuspend/${account_id}`);
  }
  unreject(account_id) {
    return requestData("POST", `/ott/unreject/${account_id}`);
  }
  terminate(account_id, reason) {
    return requestData("POST", `/ott/retire/${account_id}`, { reason });
  }
  delete(account_id) {
    return requestData("DELETE", `/ott/delete/${account_id}`);
  }
  getOTTAccountStatus(){
    return requestData("GET",`/query/ott/status`);
  }
}
